import React from 'react';

function WatchList(props) {
    return <aside className="block col-1">
    <h2>My Anime List</h2>
    </aside>
}

export default WatchList;